import { AUTH_DOMAIN } from '@config/environment';
import { i18n } from '@lib/i18n';

const changePlatform = (): void => {
    window.location.href = AUTH_DOMAIN + '/' + i18n.language;
};

export { changePlatform };
